import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import { NextSeo } from 'next-seo';
import {
  doc,
  getDoc,
  query,
  where,
  getDocs,
  collection,
} from 'firebase/firestore/lite';

import { firebaseFireStore } from '../../../config/firebaseFirestore.js';
import Navbar from '../../../components/Navbars/AppNavbar.js';
import Footer from '../../../components/Footers/Footer.js';
import FooterSM from '../../../components/Footers/FooterSmall.js';
import NftDetailsComponent from '../../../components/NftDetails/index';
import NftSchema from '../../../schema/NftSchema';

export default function MultiNftDetailPage(props) {
  const router = useRouter();
  const { nftId, multiNftId } = router.query;

  const [nftData, setnftData] = useState(null);
  const [musicData, setmusicData] = useState(null);
  const [isAdmin, setisAdmin] = useState(false);

  const userDataRedux = useSelector((state) => state.authReducer.userData);
  const isUserDataFetched = useSelector(
    (state) => state.authReducer.isUserDataFetched,
  );

  // url
  useEffect(() => {
    router.beforePopState((cb) => {
      if (cb.as === '/discover') {
        window.location.href = cb.as;
        return false;
      }
      return true;
    });
  }, []);

  useEffect(() => {
    if (props.nftData) {
      setnftData(props.nftData);
    }
  }, [props.nftData]);

  useEffect(() => {
    if (props.musicData) {
      setmusicData(props.musicData);
    }
  }, [props.musicData]);

  useEffect(() => {
    if (!props.nftData && props.mounted && isUserDataFetched) {
      if (isUserDataFetched && userDataRedux) {
        //checking if user is owner of nft or admin
        checkUserState();
      } else {
        router.push('/discover');
      }
    }
  }, [props.nftData, props.mounted, userDataRedux, isUserDataFetched]);

  const checkUserState = async () => {
    const summary = await getDoc(doc(firebaseFireStore, 'musicartNfts', nftId));

    if (
      summary.data() &&
      summary.data().usersId &&
      userDataRedux.uid &&
      summary.data().usersId.includes(userDataRedux.uid) &&
      summary.data().multipleNftDetails[multiNftId].userId === userDataRedux.uid
    ) {
      //user owns nft
      console.log('is owner');
      getNftData(summary.data());
    } else {
      console.log('is not owner');
      // check admin state
      let adminExit = await adminStateCheck();
      if (adminExit) {
        console.log('is admin');
        getNftData(summary.data());
      } else {
        console.log('not admin');
        router.push('/discover');
      }
    }
  };

  const getNftData = async (data) => {
    let lNftData = { ...data };
    if (!lNftData) {
      const summary = await getDoc(
        doc(firebaseFireStore, 'musicartNfts', nftId),
      );
      lNftData = { ...summary.data() };
    }

    const details = await getDoc(
      doc(firebaseFireStore, 'musicartNfts', nftId, 'nftData', 'details'),
    );

    lNftData = {
      ...lNftData,
      ...details.data(),
    };

    let dbRef = await getDoc(
      doc(firebaseFireStore, 'musicartArtists', lNftData.artistId),
    );
    let artistData = { ...dbRef.data(), artistId: dbRef.id };

    setnftData({ ...lNftData });
    setmusicData({ ...artistData });
  };

  const adminStateCheck = async () => {
    return await getDoc(doc(firebaseFireStore, 'admin', 'adminList')).then(
      (doc) => {
        if (
          doc.exists &&
          doc.data() &&
          doc.data().admins.includes(userDataRedux.uid)
        ) {
          //user is admin
          setisAdmin(true);
          return true;
        }
        return false;
      },
    );
  };

  return (
    <>
      <div className="relative">
        <Navbar transparent />
        {nftData && (
          <NftDetailsComponent
            data={nftData}
            musicData={musicData}
            isAdmin={isAdmin}
            isMultiple={true}
            bsvRate={props.bsvRate}
          />
        )}
        <Footer />
        <FooterSM />
      </div>
    </>
  );
}

export async function getServerSideProps(context) {
  const { nftId, multiNftId } = context.params;
  const summary = await getDoc(doc(firebaseFireStore, 'musicartNfts', nftId));

  var data = null;
  var artistData = null;

  if (
    summary.data() &&
    summary.data().activeInMarketPlace &&
    summary.data().adminState === 'ACCEPT' &&
    summary.data().multipleNftDetails[multiNftId] &&
    summary.data().multipleNftDetails[multiNftId].activeInMarketPlace &&
    summary.data().multipleNftDetails[multiNftId]?.adminState === 'ACCEPT'
  ) {
    const details = await getDoc(
      doc(firebaseFireStore, 'musicartNfts', nftId, 'nftData', 'details'),
    );

    data = {
      ...summary.data(),
      ...details.data(),
    };

    let dbRef = await getDoc(
      doc(firebaseFireStore, 'musicartArtists', data.artistId),
    );
    artistData = { ...dbRef.data(), artistId: dbRef.id };
  }

  //bsvrate
  let rate = null;
  let bsvData = await getDoc(doc(firebaseFireStore, 'exchangeRates', 'bsv'));
  if (bsvData.exists) {
    if (bsvData.data() && bsvData.data().rate) {
      rate = Number(bsvData.data().rate);
    }
  }

  return {
    props: {
      nftData: JSON.parse(JSON.stringify(data)),
      musicData: JSON.parse(JSON.stringify(artistData)),
      bsvRate: rate,
      mounted: true,
    },
  };
}
